<template>
  <div visual>
    <img :src="`/static/img/common/vis-${type}.s.png`" class="hidden-lg-up">
    <div class="bg hidden-md-down" :style="`background-image:url(/static/img/common/vis-${type}.l.png)`"></div>
    <div class="txt">
      <slot />
    </div>
    <sns class="hidden-md-down" />
  </div>
</template>

<style lang="less" scoped>
  @import "../less/asset";
  @import "../less/gynpad";

  [visual] { .tc; .rel;
    img { .block; max-width:100%; .m-hc; }
    .txt { .lt; width:100%;
      h2 { margin-top:20%; .fs(2.91rem); .oswald; color:#f85c70; }
      h3 { .fsl(1.25rem,1.5); color:#000; }
    }
  }

  @media (min-width: @screen-lg-min) {
    [visual] {
      .bg { height:428px; background:#eaeaee center no-repeat; }
      .txt { .lt; width:100%;
        h2 { margin-top:146px; .fsl(100px,1); }
        h3 { margin-top:30px; .fsl(26px,1); }
      }
    }
    [sns] {
      .lb;
    }
  }
</style>

<script>
import Sns from '../components/Sns.vue';

export default {
  name: 'TopVisual',
  props: ['type'],
  components: { Sns },
};
</script>




// WEBPACK FOOTER //
// src/components/TopVisual.vue